module.exports = __webpack_public_path__ + "static/media/logo.675771c1.jpg";